import { TrackingHandlerService } from '../../src/app/shared/services/tracking/tracking-handler.service';
import { SharedDataTriggerService } from 'src/app/shared/services/shared-data-in-form-center/shared-data-trigger.service';
import { RouterService } from 'src/app/shared/services/router.service';
import { AccordionInterceptor, AccordionService } from '@vfde-fe/ngx-lib/components/accordion';
import { InfoIconService } from '@vfde-fe/ngx-lib/components/info-icon';
import { SpinnerService } from '@vfde-fe/ngx-lib/components/spinner';
import { TrackingInterceptor } from '@vfde-fe/ngx-lib/plugins/tracking';
import { CustomErrorHandlerService } from '@vfde-fe/ngx-lib/services/custom-error-handler';
import { UserService } from '@vfde-fe/ngx-lib/services/user';

/** APP_PROVIDERS */
export const APP_PROVIDERS = [
    RouterService,
    SpinnerService,
    TrackingInterceptor,
    AccordionService,
    AccordionInterceptor,
    RouterService,
    CustomErrorHandlerService,
    InfoIconService,
    UserService,
    TrackingHandlerService,
    SharedDataTriggerService,
];
